export const QUERY_KEY = {
  GET_QUESTION_LIST: 'GET_QUESTION_LIST',
  GET_QUESTION_TAG_LIST: 'GET_QUESTION_TAG_LIST',
};
